import { Link } from 'react-router-dom';
import { PaintBrushIcon } from '@heroicons/react/24/outline';
import { Badge } from '@oysterjs/ui/badge';
import {
  DOCUMENT_PROVENANCE_CLASSES,
  DocumentProvenanceLabel
} from './artifact-focus-html-document-provenance';

const AGENCY_TEMPLATE_FALLBACK_LABEL = 'Agency template';

type DocumentTemplateBadgeProps = {
  htmlDocumentTemplateId: string;
  templateTitle?: string | null;
  control?: boolean;
};

export function DocumentTemplateBadge({
  htmlDocumentTemplateId,
  templateTitle,
  control = false
}: DocumentTemplateBadgeProps) {
  const label =
    templateTitle != null && templateTitle.trim() !== ''
      ? templateTitle.trim()
      : AGENCY_TEMPLATE_FALLBACK_LABEL;
  return (
    <Link
      to={`/app/library/templates/${htmlDocumentTemplateId}`}
      target="_blank"
      className={control ? DOCUMENT_PROVENANCE_CLASSES : undefined}
      title={
        templateTitle
          ? `View applied template: ${templateTitle}`
          : 'View applied template in Templates'
      }
    >
      {control ? (
        <>
          <PaintBrushIcon className="size-3.5 shrink-0" />
          <DocumentProvenanceLabel label="Template" name={label} />
        </>
      ) : (
        <Badge color="sky" className="text-xs max-w-64 truncate">
          <PaintBrushIcon className="size-3" />
          {label}
        </Badge>
      )}
    </Link>
  );
}
